
import Promise from "plugins/bluebird"

import {
  requestIdleCallback,
} from "plugins/request-animation-frame-polyfill"

const onLoad = () => {
  requestIdleCallback(() => {
    Promise.resolve(
      import("./sections/mobile_lister_app_smart_banner/onLoad")
    )
    .then(({default: lister_app_banner}) => {
      lister_app_banner.onLoad()
    })

    Promise.resolve(
      import("./sections/mobile_searcher_app_smart_banner/onLoad")
    )
    .then(({default: searcher_app_banner}) => {
      searcher_app_banner.onLoad()
    })
  })
}

export default { onLoad }
